/**
 * Utilitare partajate — Piața Micilor Producători.
 */
import {
  Carrot, Milk, Beef, Egg, Hexagon, Wheat, Cherry, Wine,
  Leaf, Hammer, Shirt, Armchair, Sprout, Package,
} from 'lucide-react';

export const PIATA_CATEGORIES = [
  { id: 'legume-fructe', label: 'Legume & Fructe', icon: Carrot },
  { id: 'lactate-branzeturi', label: 'Lactate & Brânzeturi', icon: Milk },
  { id: 'carne-mezeluri', label: 'Carne & Mezeluri', icon: Beef },
  { id: 'oua-pasari', label: 'Ouă & Păsări de curte', icon: Egg },
  { id: 'miere-apicole', label: 'Miere & Produse apicole', icon: Hexagon },
  { id: 'panificatie-patiserie', label: 'Panificație & Patiserie', icon: Wheat },
  { id: 'conserve-dulceturi', label: 'Conserve, Dulcețuri & Zacuscă', icon: Cherry },
  { id: 'bauturi-vinuri', label: 'Băuturi, Vinuri & Țuică', icon: Wine },
  { id: 'cosmetice-naturale', label: 'Cosmetice naturale & Săpunuri', icon: Leaf },
  { id: 'artizanat-handmade', label: 'Artizanat & Handmade', icon: Hammer },
  { id: 'textile-tesaturi', label: 'Textile & Țesături', icon: Shirt },
  { id: 'lemn-mobilier', label: 'Lemn & Mobilier', icon: Armchair },
  { id: 'plante-gradina', label: 'Plante, Semințe & Grădină', icon: Sprout },
  { id: 'altele', label: 'Alte produse', icon: Package },
];

export const catMeta = (id) => PIATA_CATEGORIES.find((c) => c.id === id) || { id, label: id, icon: Package };

export const imgUrl = (p) => (p?.startsWith('http') ? p : `${process.env.REACT_APP_BACKEND_URL}${p}`);

export const fmtRON = (v) =>
  `${Number(v || 0).toLocaleString('ro-RO', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} RON`;

export const ORDER_STATUS_LABELS = {
  noua: 'Nouă',
  confirmata: 'Confirmată',
  expediata: 'Expediată',
  finalizata: 'Finalizată',
  anulata: 'Anulată',
};

export const ORDER_STATUS_STYLES = {
  noua: 'bg-violet-50 text-violet-800 border-violet-200',
  confirmata: 'bg-blue-50 text-blue-800 border-blue-200',
  expediata: 'bg-amber-50 text-amber-900 border-amber-200',
  finalizata: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  anulata: 'bg-zinc-100 text-zinc-500 border-zinc-200',
};

export const UNITS = ['buc', 'kg', '100 g', 'litru', 'borcan', 'legătură', 'set', 'cutie', 'm²', 'altul'];
